'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.JqxGrid', ['jqwidgets', 'AVRO.Common.GridPanel', 'AVRO.Common.FileSave']).controller('JqxGridController', require('./controllers/JqxGridController')).directive('rmJqxGrid', require('./directives/JqxGridDirective'));